import { em } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  margin-left: ${em(-24)};
  align-items: baseline;
  padding-top: ${em(10)};
  text-align: left;
  padding-left: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-left: ${em(17)};
    padding-bottom: ${em(10)};
  }

  ${p => p.theme.mq.upLg} {
    padding-left: ${em(17)};
  }
`

export const CheckIcon = styled.div`
  margin-right: ${em(9)};
  transform: translateY(${em(5)});
  width: ${p => p.theme.typography.priceBaseBold};
  height: ${p => p.theme.typography.priceBaseBold};
  background: ${p => p.theme.colors[p.bg]};
  flex: 0 0 auto;
  border-radius: 50%;
`
